import reportTypesMessages from "../../report-types/constants/messages.i18n";
import { getReportTypesText } from "../../report-types/constants/reportTypes";
import messages from "./messages.i18n";
const formatPlanTitle = (title) => {
    const normalized = title.trim().toLowerCase();
    return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
};
export const getReportDescriptionText = (intl) => {
    const reportTypesText = getReportTypesText(intl);
    return {
        featuresColumnTitle: intl.formatMessage(messages.featuresColumnTitle),
        planTitles: reportTypesText.reduce((acc, reportType) => (Object.assign(Object.assign({}, acc), { [reportType.id]: formatPlanTitle(reportType.title) })), {}),
        rows: [
            {
                id: "ai-models",
                label: intl.formatMessage(messages.aiModelsFeatureLabel),
                values: {
                    basic: intl.formatMessage(messages.geminiOnlyValue),
                    premium: intl.formatMessage(messages.allFourModelsValue),
                    enterprise: intl.formatMessage(messages.allFourModelsValue),
                },
            },
            {
                id: "report-frequency",
                label: intl.formatMessage(messages.reportFrequencyFeatureLabel),
                values: {
                    basic: intl.formatMessage(reportTypesMessages.basicPlanFeatureMonthlyReports),
                    premium: intl.formatMessage(reportTypesMessages.premiumPlanFeatureMonthlyReports),
                    enterprise: intl.formatMessage(messages.customizableReportFrequencyValue),
                },
            },
            {
                id: "competitor-analysis",
                label: intl.formatMessage(reportTypesMessages.basicPlanFeatureCompetitorAnalysis),
                values: {
                    basic: intl.formatMessage(messages.basicCompetitorAnalysisValue),
                    premium: intl.formatMessage(messages.detailedCompetitorAnalysisValue),
                    enterprise: intl.formatMessage(messages.detailedCompetitorAnalysisValue),
                },
            },
            {
                id: "visibility-score",
                label: intl.formatMessage(messages.visibilityScoreFeatureLabel),
                values: {
                    basic: true,
                    premium: true,
                    enterprise: true,
                },
            },
            {
                id: "recurring-reports",
                label: intl.formatMessage(messages.recurringReportsFeatureLabel),
                values: {
                    basic: true,
                    premium: true,
                    enterprise: true,
                },
            },
            {
                id: "customizable-topics",
                label: intl.formatMessage(reportTypesMessages.premiumPlanFeatureCustomizableTopics),
                values: {
                    basic: false,
                    premium: true,
                    enterprise: true,
                },
            },
            {
                id: "community-level-billing",
                label: intl.formatMessage(reportTypesMessages.enterprisePlanFeatureCommunityLevelBilling),
                values: {
                    basic: false,
                    premium: false,
                    enterprise: true,
                },
            },
            {
                id: "white-glove-implementation",
                label: intl.formatMessage(reportTypesMessages.enterprisePlanFeatureWhiteGloveImplementation),
                values: {
                    basic: false,
                    premium: false,
                    enterprise: true,
                },
            },
        ],
    };
};
